module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('eurus-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('eurus-banner'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('eurus-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9",
    attrs: {
      "id": "main-router-view"
    }
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-249cc922","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 38
// module chunks = 11